module.exports = __webpack_public_path__ + "img/display1.2fff1c86.jpg";